<template>
  <div class="rj-col-3">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        区域商务专员<span class="required">*</span>：
      </div>
      <div class="rj-baseinfo__item">
        <el-form-item prop="regionBusinessCommissionerId">
          <el-select
            ref="region"
            v-model="form.regionBusinessCommissionerId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width:100%;"
            @change="change"
          >
            <el-option
              v-for="item in list"
              :key="item.assistantUserID"
              :label="item.assistantUserName"
              :value="item.assistantUserID"
            />
          </el-select>
        </el-form-item>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getAssistantInfo } from '@/API';
let timer;
export default {
  data () {
    return {
      list: [],
      loading: false
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {},
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.loading = true;
          getAssistantInfo(query).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.list = json.data;
            }
          }).catch(() => {
            this.loading = false;
          });
        }, 200);
      }
    },
    change (val) {
      this.$nextTick(() => {
        this.form.regionBusinessCommissioner = this.$refs.region.selectedLabel;
      });
    },
    initData () {
      if (this.form.regionBusinessCommissionerId) {
        this.list = [{
          assistantUserName: this.form.regionBusinessCommissioner,
          assistantUserID: this.form.regionBusinessCommissionerId
        }];
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
